import { Modal, Form, Input, Select, Row, Col } from "antd";
import { useEffect } from "react";
import PageHeader from "../../../components/headers/PageHeader";

const { Option } = Select;

export default function ModalUbicacion({
  open,
  setOpen,
  type = "crear",
  ubicacion = {},
  onSubmit,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (type === "editar" && ubicacion) {
      form.setFieldsValue({
        name: ubicacion.name,
        specific: ubicacion.specific,
        zone: ubicacion.zone,
        means: ubicacion.means,
        typeLocation: ubicacion.type,
        lat: ubicacion.geolocation?.lat,
        lon: ubicacion.geolocation?.lon,
      });
    } else {
      form.resetFields();
    }
  }, [type, ubicacion, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const finalPayload = {
        name: values.name,
        specific: values.specific,
        zone: values.zone,
        means: values.means,
        type: values.typeLocation,
        geolocation: {
          lat: parseFloat(values.lat),
          lon: parseFloat(values.lon),
        },
      };
      onSubmit(finalPayload);
      setOpen(false);
    } catch (err) {
      console.error("Error al validar campos:", err);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      open={open}
      title={
        <PageHeader
          title={type === "editar" ? "Editar Ubicación" : "Crear Ubicación"}
        ></PageHeader>
      }
      onCancel={handleCancel}
      onOk={handleOk}
      okText={type === "editar" ? "Guardar cambios" : "Crear"}
      cancelText="Cancelar"
      width={700}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nombre"
              name="name"
              rules={[
                { required: true, message: "Por favor ingresa el nombre" },
              ]}
            >
              <Input placeholder="Ej: Aurora" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Código específico"
              name="specific"
              rules={[
                { required: true, message: "Por favor ingresa el código" },
              ]}
            >
              <Input placeholder="Ej: AUR" maxLength={5} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="Zona"
              name="zone"
              rules={[{ required: true, message: "Seleccione una zona" }]}
            >
              <Select placeholder="Selecciona zona">
                {[1, 2, 3, 4, 5, 6].map((zona) => (
                  <Option key={zona} value={zona}>
                    {zona}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Medio"
              name="means"
              rules={[{ required: true, message: "Seleccione un medio" }]}
            >
              <Select placeholder="Selecciona medio">
                <Option value="Metro">Metro</Option>
                <Option value="Cable">Cable</Option>
                <Option value="Tranvía">Tranvía</Option>
                <Option value="Bus">Bus</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Tipo de Locación"
              name="typeLocation"
              rules={[{ required: true, message: "Seleccione un tipo" }]}
            >
              <Select placeholder="Selecciona tipo">
                <Option value="ESTACION">ESTACIÓN</Option>
                <Option value="INTER-ESTACION">INTER-ESTACION</Option>
                <Option value="TRANVIA">TRANVIA</Option>
                <Option value="PATIO">PATIO</Option>
                <Option value="PARADA">PARADA</Option>
                <Option value="INTER-PARADA">INTER-PARADA</Option>
                <Option value="PARADERO">PARADERO</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Latitud"
              name="lat"
              rules={[{ required: true, message: "Ingresa latitud" }]}
            >
              <Input type="number" placeholder="Latitud" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Longitud"
              name="lon"
              rules={[{ required: true, message: "Ingresa longitud" }]}
            >
              <Input type="number" placeholder="Longitud" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
